var React = require('react');

function ElvelopeIcon (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#fff"},[React.createElement("path",{"d":"M.482 1.217c.064.045.256.179.576.4a140.682 140.682 0 0 1 1.005.704c.04.027.09.058.146.092a.91.91 0 0 0 .161.075.446.446 0 0 0 .14.025h.006c.043 0 .09-.008.14-.025a.847.847 0 0 0 .162-.075 2.962 2.962 0 0 0 .297-.198c.061-.044.1-.073.12-.086l1.312-.912c.137-.095.251-.21.343-.345A.74.74 0 0 0 5.027.45a.43.43 0 0 0-.133-.317A.434.434 0 0 0 4.578 0H.448a.4.4 0 0 0-.332.146A.566.566 0 0 0 0 .51c0 .117.051.245.154.382.103.138.213.246.328.324z","key":0}),React.createElement("path",{"d":"M4.747 1.518A58.303 58.303 0 0 0 3.09 2.669a1.601 1.601 0 0 1-.265.135.807.807 0 0 1-.309.069h-.005a.807.807 0 0 1-.309-.07 1.602 1.602 0 0 1-.265-.134 6.644 6.644 0 0 1-.26-.184 56.172 56.172 0 0 0-1.394-.967A1.486 1.486 0 0 1 0 1.274V3.5c0 .123.044.229.132.317a.432.432 0 0 0 .317.132h4.13a.43.43 0 0 0 .316-.132.432.432 0 0 0 .132-.317V1.274c-.08.09-.174.17-.28.244z","key":1})]));
}

ElvelopeIcon.defaultProps = {"width":"19","height":"14.928","viewBox":"0 0 5.027 3.95"};

module.exports = ElvelopeIcon;

ElvelopeIcon.default = ElvelopeIcon;



//////////////////
// WEBPACK FOOTER
// /node_modules/svg-react-loader/lib/loader.js?name=ElvelopeIcon!./assets/images/social/envelope.svg
// module id = s/R8
// module chunks = 0